import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadListFailure,
  loadListSuccess,
  loadPortfolioTypesList,
  toggleLoadingStatus,
} from './portfolio-types.actions';
import { selectPortfolioTypesList, selectPortfolioTypesLoading } from './portfolio-types.selectors';

@Injectable()
export class UIEffect {
  private readonly action = inject(Actions);
  private readonly store = inject(Store);
  private readonly service = inject(ReferenceService);

  constructor() {}

  loadPortfolioTypesList = createEffect(() =>
    this.action.pipe(
      ofType(loadPortfolioTypesList),
      withLatestFrom(this.store.select(selectPortfolioTypesList), this.store.select(selectPortfolioTypesLoading)),
      filter(([action, state, status]) => !state?.length && !status),
      tap(() => this.store.dispatch(toggleLoadingStatus({ status: true }))),
      switchMap((action) =>
        this.service.referenceSasSecLookupGetPortfolioTypesGet().pipe(
          switchMap((response) => of(loadListSuccess({ payload: response.result }))),
          catchError((error) => of(loadListFailure({ error }))),
        ),
      ),
    ),
  );
}